import base from './base';

export default {
  update(formData) {
    return base.postFormData('user/profile', formData);
  },

  changePassword({ password, password_confirmation }) {
    return base.postFormData('user/change-password', { password, password_confirmation });
  },

  apply(formData) {
    return base.postFormData('user/apply', formData);
  },
}
